export const validateName = (_: any, value: any) => {
  const nameRegex = /^[a-zA-ZñÑ\s]+$/;
  if (value && !nameRegex.test(value)) {
    return Promise.reject(new Error("No debe contener caracteres especiales"));
  }

  const lengthNameRegex = /^.{2,80}$/;
  if (value && !lengthNameRegex.test(value)) {
    return Promise.reject(new Error("Debe contener de 2 a 80 letras"));
  }
  return Promise.resolve();
};

export const validateIntegerNumber = (_: any, value: any) => {
  const priceRegExp = /^\d+$/; // Regular expression for one or more digits (integer)
  if (!value || !priceRegExp.test(value)) {
    return Promise.reject(new Error("Please enter a valid integer number"));
  }
  return Promise.resolve();
};

export const validatePositiveIntegerNumber = (_: any, value: any) => {
  const priceRegExp = /^\d+$/; // Regular expression for one or more digits (integer)
  if (!value || !priceRegExp.test(value) || value <= 0) {
    return Promise.reject(
      new Error("Favor de ingresar un número entero positivo"),
    );
  }
  return Promise.resolve();
};

export const validateNonNegativeNumber = (_: any, value: any) => {
  const priceRegExp = /^\d+$/; // Regular expression for one or more digits (integer)
  if ((value && !priceRegExp.test(value)) || value < 0) {
    return Promise.reject(
      new Error("Favor de ingresar un número mayor o igual a 0"),
    );
  }
  return Promise.resolve();
};

export const validatePropertyAlias = (_: any, value: any) => {
  if (value && value.length > 50) {
    return Promise.reject(new Error("Debe contener menos de 51 caractéres"));
  }
  return Promise.resolve();
};

export const validatePropertyStreet = (_: any, value: any) => {
  if (value && value.length > 80) {
    return Promise.reject(new Error("Debe contener menos de 81 caractéres"));
  }
  return Promise.resolve();
};

export const validatePropertyExteriorNumber = (_: any, value: any) => {
  if (value && value.length > 10) {
    return Promise.reject(new Error("Debe contener menos de 11 caractéres"));
  }
  return Promise.resolve();
};

export const validateOrganizationName = (_: any, value: any) => {
  const nameRegex = /^[a-zA-Z0-9\s]{2,80}$/;
  if (value && !nameRegex.test(value)) {
    return Promise.reject(new Error("Debe contener de 2 a 80 letras"));
  }
  return Promise.resolve();
};
